import Swiper from 'swiper';
import { Navigation, FreeMode } from 'swiper/modules';
import sliderADA from '../../components/slider/ada';

const normalizeSubcategorySlidesA11y = (sliderRoot) => {
  if (!sliderRoot) return;

  sliderRoot.querySelectorAll('.collection-subcategories__item[role]').forEach((item) => {
    item.removeAttribute('role');
  });
};

const initSlider = () => {
  const sub_categories_container = document.querySelector('[data-collection-subcategories]');
  const sub_categories_slider = sub_categories_container.querySelector('[data-collection-subcategories-slider]');

  const slider_modules = [Navigation, FreeMode];

  const slider_settings = {
    modules: slider_modules, // https://swiperjs.com/swiper-api#using-js-modules
    slidesPerView: 'auto',
    spaceBetween: 18,
    loop: false,
    freeMode: true,
    navigation: {
      nextEl: '[data-collection-subcategories] .swiper-button-next',
      prevEl: '[data-collection-subcategories] .swiper-button-prev',
    },
    breakpoints: {
      769: {
        spaceBetween: 28,
        slidesPerGroup: 5,
        freeMode: false,
        navigation: {
          nextEl: '[data-collection-subcategories] .swiper-button-next',
          prevEl: '[data-collection-subcategories] .swiper-button-prev',
        },
      },
    },
    on: {
      init: function () {
        sliderADA(sub_categories_slider);
        normalizeSubcategorySlidesA11y(sub_categories_slider);
      },
    }
  };

  new Swiper(sub_categories_slider, slider_settings);
};

const subCategoryTemplate = (subcat, isActive) => `
  <li 
    class="collection-subcategories__item${isActive ? ' active' : ''} swiper-slide" 
    aria-label="Navigate to: ${subcat.title}"
    data-pos="${subcat.position}"
    tabindex="0"
  >
    <a href="${subcat.url}" class="collection-subcategories__cta" tabindex="0">
      <div class="collection-subcategories__title">${subcat.title}</div>
    </a>
  </li>
`;

export default () => {
  const subcat_container = document.querySelector('[data-collection-subcategories-slider]');
  if (!subcat_container) return false;

  const sub_categories_el = document.querySelector('[data-collection-sub-categories-json]');
  if (!sub_categories_el || sub_categories_el.textContent.trim() === '') {
    subcat_container.remove();
    return false;
  }

  const sub_categories_json = JSON.parse(sub_categories_el.textContent);
  if (!Array.isArray(sub_categories_json) || sub_categories_json.length === 0) return false;
  else sub_categories_json.sort((a, b) => a.position - b.position);

  const currentHandle = window.theme?.collections?.current;
  const sub_categories_html = sub_categories_json.map(subcat =>
    subCategoryTemplate(subcat, currentHandle === subcat.handle)
  ).join('') +
    `<li class="collection-subcategories__item collection-subcategories__item--last swiper-slide" aria-label="Last">&nbsp;</li>`;

  const div = subcat_container.querySelector('ul');
  if (div) div.innerHTML = sub_categories_html;

  subcat_container.classList.remove('loading');
  subcat_container.classList.add('loaded');
  normalizeSubcategorySlidesA11y(subcat_container);

  initSlider();
};
